import React, { FormEventHandler } from "react";
import { SubmitHandler, UseFormRegister, useForm } from "react-hook-form";
import { useDallE } from "../../../api/calls/OpenAi";
import { QueryObserverResult, useQueryClient } from "@tanstack/react-query";
import GeneratedImagesGrid from "./GeneratedImagesGrid";
import { Asset, TourData } from "../../../Types";
import { AxiosError } from "axios";

const DalleWrapper = (props: {
  selectedAsset: number | string | undefined;
  setSelectedAsset: React.Dispatch<
    React.SetStateAction<number | string | undefined>
  >;
  setPage: React.Dispatch<React.SetStateAction<1 | 2 | 3>>;
  refetch: () => Promise<QueryObserverResult<Asset[] | undefined>>;
  tourData: TourData;
}) => {
  const { refetch, selectedAsset, setSelectedAsset, setPage, tourData } = props;

  const [images, setImages] = React.useState<
    { url: string; index: number }[] | undefined
  >();
  const { handleSubmit, register } = useForm<{ input: string }>();
  const [prompt, setPrompt] = React.useState<string>();

  const { mutateAsync, isPending, isError, error } = useDallE();

  const queryClient = useQueryClient();

  const fetchFromDallE = React.useCallback(
    (input: string) => {
      return mutateAsync(
        { prompt: input, numberOfImages: 4 },
        {
          onSuccess: (data: { url: string; index: number }[]) =>
            setImages(data),
        }
      );
    },
    [mutateAsync]
  );

  const onSubmit: SubmitHandler<{ input: string; forceQuery?: boolean }> = (
    data
  ) => {
    setPrompt(data.input);

    const queryResult: { url: string; index: number }[] | undefined =
      queryClient.getQueryData([
        "DallEResult",
        data.input.toLocaleLowerCase().replace(/\s/g, ""),
      ]);

    if (queryResult) {
      console.debug("existing query");
      setImages(queryResult);
    } else {
      fetchFromDallE(data.input);
    }
  };

  const page = React.useMemo(() => {
    if (images?.length && images.length > 0) return 1;
    else return 0;
  }, [images]);

  return (
    <div className="dalle">
      {page === 0 ? (
        <PromptSubmittingPage
          isError={isError}
          handleSubmit={handleSubmit(onSubmit)}
          register={register}
          isPending={isPending}
          error={error}
        />
      ) : (
        <GeneratedImagesGrid
          isPending={isPending}
          isError={isError}
          images={images!}
          setImages={setImages}
          prompt={prompt}
          setSelectedAsset={setSelectedAsset}
          refetchDallE={fetchFromDallE}
          refetch={refetch}
          setPage={setPage}
        />
      )}
    </div>
  );
};

const PromptSubmittingPage = (props: {
  handleSubmit: FormEventHandler<HTMLFormElement>;
  register: UseFormRegister<{ input: string }>;
  isPending: boolean;
  isError: boolean;
  error: Error | null;
}) => {
  const { handleSubmit, register, isError, isPending } = props;
  // @ts-expect-error
  const requestError: AxiosError | undefined = props.error;
  // @ts-expect-error
  const errorMsg: string | undefined = requestError?.response?.data;

  return (
    <div className="dalle-prompt">
      <form onSubmit={handleSubmit}>
        <input
          disabled={isPending}
          {...register("input", { required: true })}
          type="text"
          id="dalle"
          placeholder="Inserisci un prompt"
        ></input>
        <button type="submit" id="dalle-submit" disabled={isPending}>
          Invia Prompt
        </button>
      </form>

      {isError && requestError && errorMsg && (
        <pre>
          {requestError.code}
          <br />
          {errorMsg}
        </pre>
      )}
      <div
        style={{
          visibility: !isPending ? "hidden" : "visible",

          position: "absolute",
          top: 0,
          background: "#fff5",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: 50,
            height: 50,
            borderRightColor: "#10a37f",
            borderWidth: "6px",
          }}
          id="spinner"
        ></div>
      </div>
    </div>
  );
};

export default DalleWrapper;
